(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rc-back"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(event) {
  const link = event.target.closest('a.rc-back');
  if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  try {
    const previous = new URL(document.referrer);
    if (previous.origin === location.origin && previous.pathname !== location.pathname && history.length > 1) {
      event.preventDefault();
      history.back();
    }
  } catch (_) {}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rc-catalog-grid"] && !Shopify.designMode) return;
  try {
    (() => {
  const init = (scope) => {
    scope.querySelectorAll('[data-rc-catalog][data-complete="true"]').forEach((catalog) => {
      if (catalog.dataset.rcFilterReady === 'true') return;
      catalog.dataset.rcFilterReady = 'true';
      const cards = Array.from(catalog.querySelectorAll('.rcs-card'));
      const links = Array.from(catalog.querySelectorAll('.rc-catalog-filters [data-rc-category]'));
      const count = catalog.querySelector('[data-rc-count]');
      links.forEach((link) => link.addEventListener('click', (event) => {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        const category = link.dataset.rcCategory;
        let visibleCount = 0;
        cards.forEach((card) => {
          const visible = category === 'all' || card.dataset.rcCategory === category;
          card.hidden = !visible;
          if (visible) visibleCount += 1;
        });
        links.forEach((item) => {
          if (item === link) item.setAttribute('aria-current', 'true');
          else item.removeAttribute('aria-current');
        });
        count.textContent = count.dataset.countTemplate.replace('[count]', String(visibleCount));
      }));
    });
  };
  init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rc-commerce"] && !Shopify.designMode) return;
  try {
    (() => {
  const selectVariant = (root, index) => {
    const radios = Array.from(root.querySelectorAll('.rcs-options input[type="radio"]'));
    if (!radios.length) return;
    const normalized = (index + radios.length) % radios.length;
    const apply = () => {
      radios[normalized].checked = true;
      radios[normalized].dispatchEvent(new Event('change', { bubbles: true }));
    };
    if (document.startViewTransition) document.startViewTransition(apply);
    else apply();
  };
  const initProduct = (root) => {
    if (root.dataset.rcsReady === 'true') return;
    root.dataset.rcsReady = 'true';
    const radios = Array.from(root.querySelectorAll('.rcs-options input[type="radio"]'));
    const thumbs = Array.from(root.querySelectorAll('[data-rcs-variant]'));
    const sync = () => {
      const checked = radios.find((radio) => radio.checked);
      thumbs.forEach((thumb) => thumb.setAttribute('aria-pressed', String(checked && thumb.dataset.rcsVariant === checked.value)));
    };
    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const index = radios.findIndex((radio) => radio.value === thumb.dataset.rcsVariant);
        selectVariant(root, index);
      });
    });
    root.querySelectorAll('[data-rcs-direction]').forEach((button) => {
      button.addEventListener('click', () => {
        const current = radios.findIndex((radio) => radio.checked);
        selectVariant(root, current + Number(button.dataset.rcsDirection));
      });
    });
    radios.forEach((radio) => radio.addEventListener('change', sync));
    sync();
  };
  const initPhotoRail = (carousel) => {
    if (carousel.dataset.rcsReady === 'true') return;
    carousel.dataset.rcsReady = 'true';
    const track = carousel.querySelector('[data-rcs-rail-track]');
    carousel.querySelectorAll('[data-rcs-rail]').forEach((button) => {
      button.addEventListener('click', () => track.scrollBy({ left: Number(button.dataset.rcsRail) * track.clientWidth * 0.85, behavior: 'smooth' }));
    });
  };
  const init = (scope) => {
    scope.querySelectorAll('[data-rcs-product]').forEach(initProduct);
    scope.querySelectorAll('[data-rcs-photo-carousel]').forEach(initPhotoRail);
  };
  init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rc-mobile-navigation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rc-mobile-navigation')) {
    customElements.define('rc-mobile-navigation', class extends HTMLElement {
      connectedCallback() {
        requestAnimationFrame(() => {
          const rail = this.querySelector('.rc-mobile-navigation__rail');
          const active = this.querySelector('.rc-mobile-navigation__active');
          if (!rail || !rail.clientWidth) return;
          const updateEdge = () => this.classList.toggle('is-at-end', rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2);
          rail.addEventListener('scroll', updateEdge, {passive:true});
          updateEdge();
          if (!active) return;
          const bounds = rail.getBoundingClientRect();
          const selected = active.getBoundingClientRect();
          if (selected.right > bounds.right || selected.left < bounds.left) {
            rail.scrollLeft += selected.left - bounds.left - 8;
            updateEdge();
          }
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
